import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
declare const $;

@Component({
  selector: 'app-advance-game-score',
  templateUrl: './advance-game-score.component.html',
  styleUrls: ['./advance-game-score.component.css']
})
export class AdvanceGameScoreComponent implements OnChanges {

  @Input() advGamecharacterSpeech : any;
  @Input() sceneCharacters: any;
  @Input() gameFinishedData: any;
  @Input() lastScore: Array<number>;
  @Input() screenOrientataion : any;
  expressionIndex = 0;
  myScore;
  characterScore;
  teamScore;
  characterName : any;
  summaryFeedback: any;
  isLastNode: boolean = false;
  prevScoreSection: boolean = false;
  prevScore: Array<number> = [];
  screenWidth: number = 1366;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes : { [propertyName: string]: SimpleChange }){
    this.screenWidth = screen.width || window.screen.width;
    let finalScore = this.gameFinishedData.Score.split(':');

    this.myScore = finalScore[0];
    this.characterScore = finalScore[1];
    this.teamScore = parseInt(finalScore[0]) + parseInt(finalScore[1]);
    this.characterName = this.advGamecharacterSpeech.characterSpeech[0].name;

    let pathFinal = this.gameFinishedData.Path;

    let data = this.advGamecharacterSpeech.summaryFeedbacks.find(obj => obj.id == pathFinal);
    if(data){
      this.summaryFeedback = data.text;
    }

    let charSpeech = this.advGamecharacterSpeech.characterSpeech[0].text;

    $("#"+this.advGamecharacterSpeech.rootId).empty();
    $("#"+this.advGamecharacterSpeech.rootId).css('background-image','url('+this.sceneCharacters.bgImage.src+')');
    let c,clist;
    clist=this.advGamecharacterSpeech.characterSpeech;
    let charId="myimg0";
    let ctooltipId="tooltip0";
    $("#"+this.advGamecharacterSpeech.rootId).append('<div><div id="'+charId+'" class="myimg0_Adv"><div class="parentboxAdv"><div id="'+ctooltipId+'" class="speech-bubbleAdv childbox">'+charSpeech+'</div></div></div></div>');
    $("#"+ctooltipId).css("display","inline-block");
    $("#"+charId).css('background-image','url('+ this.sceneCharacters[clist[0].name+'_'+clist[0].expression[this.expressionIndex]].src+')');
    $("#"+charId).css('height','320px');
    $("#"+charId).css('width','100%');
    $("#"+charId).css('background-position','0% 38%');
    $("#"+charId).css('position','absolute');
    $("#"+charId).css('left','-12%');

    this.prevScoreSection = true;
    this.isLastNode = true;

    if(this.screenOrientataion == 90 && this.screenWidth < 1000){
      $('.responseBgContainer').css('top','0%');
      $('.gameContainer').css('height','calc(100vh - 66px)');
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/advance-game-score/advance-game-score.component.ts